import React, { Component } from 'react'
import { Upload } from '@hlj/hlj-components'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'
import { message } from 'hljd'
import Style from '../style.module.less'

const SortableItem = SortableElement(({ children }) => children)
const SortableList = SortableContainer(({ children }) => (
  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      maxHeight: '50vh',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }}
  >
    {children}
  </div>
))

export default class extends Component {
  commonConfig = {
    height: 160,
    width: 160,
    max_file_size: '10mb',
    filters: {
      mime_types: [
        {
          title: 'Image files',
          extensions: 'jpg,png,jpeg,bmp'
        }
      ]
    }
  }

  sortEnd = ({ oldIndex, newIndex }) => {
    const { value, onChange } = this.props
    const result = arrayMove(value, oldIndex, newIndex)
    onChange && onChange(result)
  }

  onOk = (file, url, info) => {
    const { width, height } = info
    const { value = [], onChange } = this.props
    let _list = [...value]
    if (_list.length === 50) {
      message.error('请最多上传50张')
      return
    }
    _list.push({ path: url, width, height })
    onChange && onChange(_list)
  }

  onDel = index => () => {
    const { value = [], onChange } = this.props
    let _list = [...value]
    _list.splice(index, 1)
    onChange && onChange(_list)
  }

  onError = (up, err, errTip) => {
    if (err.code === plupload.FILE_SIZE_ERROR) {
      message.error('文件大小超过限制，请重新选择')
    }
  }

  handleItem = index => (file, url, info) => {
    const { width, height } = info
    const { value = [], onChange } = this.props
    let _list = [...value]
    _list[index] = { path: url, width, height }
    onChange && onChange(_list)
  }

  render() {
    const { value = [] } = this.props
    return (
      <>
        <div className={Style.wrapper}>
          <SortableList
            onSortEnd={this.sortEnd}
            axis="xy"
            hideSortableGhost={false}
            pressDelay={100}
          >
            <SortableItem disabled={true} index={value.length}>
              <div className={Style['img-item']}>
                <Upload
                  onOk={this.onOk}
                  onError={this.onError}
                  link={''}
                  onBeforeUp={this.onBeforeUp}
                  description={
                    <div style={{ lineHeight: '20px', color: '#666' }}>
                      <p>点击上传本地图片</p>
                    </div>
                  }
                  multiple
                  {...this.commonConfig}
                />
              </div>
            </SortableItem>

            {value.map((item, index) => (
              <SortableItem disabled={false} index={index} key={index}>
                <div className={Style['img-item']}>
                  <Upload
                    // autoSuffix={false}
                    // clipabled
                    {...this.commonConfig}
                    link={item.path.split('?')[0]}
                    onOk={this.handleItem(index)}
                    onDelete={this.onDel(index)}
                  />
                </div>
              </SortableItem>
            ))}
          </SortableList>
        </div>
        <div className={Style.explain}>
          <div>
            1.单个图集<span className={Style.stress}>最多上传50张照片</span>
          </div>
          <div>
            2.为保证图片正常使用，仅支持<span className={Style.stress}>
              10M以内
            </span>jpg、jpeg、png格式图片上传
          </div>
        </div>
      </>
    )
  }
}
